export default {
  "content": "<path d=\"M1.703 19.628A1.5 1.5 0 003 20.375h18a1.5 1.5 0 001.302-2.244l-9-15.75a1.5 1.5 0 00-2.604 0l-9 15.75a1.5 1.5 0 00.005 1.497zm3.882-2.253L12 6.148l6.415 11.227H5.585z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "#333",
    "viewBox": "0 0 24 24"
  }
};